import React, { Suspense, lazy, useEffect, useContext } from 'react';
import { HomeCarouselMain, HomeAbout, Homecategort, HomeTechnologyNews, HomeCardSingleImagewithBlogs, HomeCardSingleBlogs } from '../components/common'
import { UseData } from '../hooks';
import { initainitialState } from '../redux/reducers/MasterReducer'

// import { StateContext } from "../components/context/ManageStates";
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { HomeCategory } from '../components/common/Homecategory';
import useApidata from '../hooks/useApidata';
// const HomeCarouselMain = lazy(() => import("../components/common/HomeCarouselMain"));
// const HomeTechnologyNews = lazy(() => import("../components/common/HomeTechnologyNews"));
// const HomeCardSingleBlogs = lazy(() => import("../components/common/HomeCardSingleBlogs"));
const Home = () => {
    // const { homedata } = useContext(initainitialState);
    // const { getNewsDatalistdata } = UseData();
    //     const dispatch = useDispatch();
    //   const { getNewsDatalistdata } = Homedata()

    //   useEffect(()=>{
    //     dispatch(getNewsDatalistdata())
    //   },[])
    // console.log("homedata :", homedata)
    const { useCategoryData } = useApidata()
    const { data, isLoading } = useCategoryData()

    const posts = data?.data?.data?.searchResult || [];
    const categories = data?.data?.data?.filters?.categories || [];

    return (
        <>

            <HomeCarouselMain />

            <HomeAbout />
            {
                categories.map((cat) => (
                    <HomeCategory
                        key={cat.maincategory_id}
                        posts={posts}
                        categoryId={cat.maincategory_id}
                        title={cat.label}
                    />
                ))
            }
            {/* <Homecategort    /> */}



        </>
    );
};

export default Home;